<template>
  <div class="coming-soon-overlay" @click.self="close">
    <div
      class="coming-soon-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="coming-soon-title"
    >
      <button type="button" class="close-btn" aria-label="Close" @click="close">
        &times;
      </button>

      <div class="modal-content">
        <div class="modal-icon">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="24"
              cy="24"
              r="18"
              stroke="currentColor"
              stroke-width="2.5"
            />
            <path
              d="M24 13V24L31 29"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2 id="coming-soon-title" class="title dark modal-title">
          COMING SOON
        </h2>

        <p class="desc dark modal-description">
          Selling skins is not available yet.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.coming-soon-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.82);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.coming-soon-modal {
  position: relative;
  width: 100%;
  max-width: 460px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  background: linear-gradient(145deg, #242832 0%, #151820 100%);
  color: #fff;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.6);
  animation: modal-appear 0.25s ease-out;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 18px;
  z-index: 2;
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 30px 55px;
  text-align: center;
}

.modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  margin-bottom: 28px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.modal-title {
  margin: 0 0 16px;
  font-family: 'Montserrat', sans-serif;
  font-size: 32px;
  font-weight: 800;
  line-height: 1.2;
  color: #fff !important;
}

.modal-description {
  max-width: 320px;
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7) !important;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 480px) {
  .coming-soon-overlay {
    padding: 16px;
  }

  .modal-content {
    padding: 52px 22px 44px;
  }

  .modal-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
  }

  .modal-title {
    font-size: 27px;
  }

  .modal-description {
    font-size: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .coming-soon-modal {
    animation: none;
  }
}
</style>
